import { render, staticRenderFns } from "./UserServiceCreate.vue?vue&type=template&id=75388650&scoped=true&"
import script from "./UserServiceCreate.vue?vue&type=script&lang=js&"
export * from "./UserServiceCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75388650",
  null
  
)

export default component.exports